























export default {
  name: "BaseLabeledSwitch",
  data: function () {
    return {
      gridTemplateColumns: "1fr",
    };
  },
  props: {
    value: {
      type: [Object, String],
    },
    values: {
      type: Array,
    },
    paddings: {
      type: String,
      default: "18px 20px",
    },
  },
  watch: {
    values: function () {
      this.gridTemplateColumns = "";
      this.values.forEach((v) => {
        this.gridTemplateColumns += " 1fr";
      });
    },
  },
  mounted() {
    this.gridTemplateColumns = "";
    this.values.forEach((v) => {
      this.gridTemplateColumns += " 1fr";
    });
  },
  methods: {
    check(val) {
      this.$emit("input", val);
    },
  },
};
